import util from '../utils/util';
var KEY_DOWN_EVENT = 'keydown.widget_dialog';

import nmcConfig from '../config/config'

var DIALOG_STRUCTOR = {
    // 历史版本结构定义
    origin: {
        containerClass: "dialog_layer_v2",
        dialogClass: "dialog_layer_main",

        headClass: "dialog_layer_title",
        bodyClass: "dialog_layer_cont",
        footerClass: "dialog_layer_ft",

        titleTag: "<h3></h3>",
        closeTag: "<a></a>",
        closeClass: "close",

        buttonWrapper: null,
        buttonTag: '<a href="javascript:void(0);"></a>',
        buttonClass: "btn",
        buttonPrimaryClass: "btn_blue",
        buttonWeakClass: "btn_white_2",
        buttonDisableClass: "btn_unclick",

        enterTransitionClass: "modal-in",
        leaveTransitionClass: "modal-out"
    },

    // 15 年新版对话框结构定义
    rich: {
        containerClass: "dialog-container",
        dialogClass: "tc-15-rich-dialog",

        headClass: "tc-15-rich-dialog-hd",
        bodyClass: "tc-15-rich-dialog-bd",
        footerClass: "tc-15-rich-dialog-ft",

        titleTag: "<strong></strong>",
        closeTag: "<button></button>",
        closeClass: "tc-15-btn-close",

        buttonWrapper: '<div class="tc-15-rich-dialog-ft-btn-wrap" />',
        buttonTag: "<button></button>",
        buttonClass: "tc-15-btn",
        buttonPrimaryClass: "",
        buttonWeakClass: "weak",
        buttonDisableClass: "disabled",

        enterTransitionClass: "modal-in",
        leaveTransitionClass: "modal-out"
    }

};

//遮罩管理
var mask = {
    render_if: function () {
        if (!dialog.mask) {
            dialog.mask = $('<div/>').css({
                'position': 'fixed',
                'left': 0,
                'top': 0,
                'z-index': '999',
                'width': '100%',
                'height': '100%',
                'opacity': '0.5',
                'background-color': '#000'
            }).appendTo($('body'));
        }
    },
    show: function () {
        dialog.mask.show();
        dialog.mask.removeClass('mask-out').addClass('mask-in');
    },
    hide: function () {
        util.animationend(dialog.mask[0], function () {
            if (dialog.mask.hasClass('mask-out')) {
                dialog.mask.hide();
            }
        });
        dialog.mask.removeClass('mask-in').addClass('mask-out');
    }
};

/**
 * 对话框
 * @class dialog
 * @static
*/
var dialog = {
    el: null,
    mainEl: null,
    contentEl: null,
    mask: null,

    /**
     * 创建对话框
     * @method create
     * @param  {String} html   html字符串
     * @param  {Number} width  宽
     * @param  {Number} height 高
     * @param  {Boolean} option.animation 弹框使用缩放动画
     * @param  {Object} option.button 按钮配置
     * @param  {String} option.title 标题
     * @param  {Boolean} option.closeIcon 是否配置删除图标
     * @param  {Boolean} option.mask 使用蒙层
     * @param  {String} option.class 容器class, @default 'dialog_layer_v2'
     * @param  {Boolean} option.isMaskClickHide 点击蒙层关闭
     * @param  {Boolean} option.defaultCancelBtn 自动补全取消按钮
     * @param  {Function} option.defaultCancelCb 默认取消行为回调
     * @param  {String} option.beforeButtonHtml 按钮前面额外的html
     * @param  {Array} option.buttonHighlight 多个button时, 指定是否高亮, 如[1,0]
     * @param  {Array} option.buttonDisable 多个button时, 指定是否灰化, 如[1,0]
     * @param  {Boolean} option.preventResubmit 防止重复提交
     * @param  {Function} option.callback iframe内回调
     * @param  {Function} option.onload 创建完毕后回调
     * @param  {String} option.owner 对话框所有者,关联名称
     * @param  {Int} option.time 延时关闭
     * @author evanyuan
     */
    create: function (html, width, height, option) {

        this.destroy();

        var _self = this;
        var config = {
            'struct': "origin", // 使用的对话框结构，取值为 "rich" 可以使用 15 年新版对话框
            'animation': true, //弹框使用缩放动画
            'button': null, //按钮配置
            'title': '', //标题
            'closeIcon': true, //是否配置删除图标
            'mask': true, //蒙层
            'isMaskClickHide': true, //点击蒙层关闭
            'defaultCancelBtn': true, //自动补全取消按钮
            'defaultCancelCb': null, //默认取消行为回调
            'beforeButtonHtml': '', //按钮前面额外的html
            'isFromConfirm': false, //从confirm组件过来
            'buttonHighlight': [], //多个button时, 指定是否高亮, 如[1,0]
            'buttonDisable': [], //多个button时, 指定是否灰化, 如[1,0]
            'preventResubmit': false, //防止重复提交
            'callback': function () { }, //iframe内回调
            'onload': null, //创建完毕后回调
            'owner': '', //对话框所有者,关联名称
            'esc': true, //esc退出
            'time': '' //延时关闭
        };

        var dialogBtnTxt = nmcConfig.dialogBtnTxt;

        var $body = $('body');
        option = option || {};
        option = this.option = $.extend({}, config, option);

        // dialog struct to use
        var struct = this.struct = DIALOG_STRUCTOR[option.struct] || DIALOG_STRUCTOR["origin"];

        if (!this.el) {
            var dialogWrap = $('<div/>').css({
                'position': 'relative',
                'zIndex': '1000'
            }),
                dialogMain = $('<div/>').addClass(struct.dialogClass),
                dialogContent = $('<div/>');

            var box = $('<div/>').css({
                'position': 'fixed',
                'top': 0,
                'right': 0,
                'bottom': 0,
                'left': 0,
                'zIndex': '1000',
                'overflow': 'auto'
            });

            box.append(dialogWrap)
            dialogMain.append(dialogContent);
            dialogWrap.append(dialogMain);
            $body.append(box);

            this.box = box;
            this.el = dialogWrap;
            this.mainEl = dialogMain;
            this.contentEl = dialogContent;
        } else {
            this.el.removeClass().addClass(struct.containerClass);
            this.mainEl.removeClass().addClass(struct.dialogClass);
            if (option.struct !== 'origin') {
                this.contentEl.removeClass().addClass(struct.bodyClass);
            }
        }

        height = (height == undefined || height == null) ? '' : height;
        width = (width == undefined || width == null) ? '' : width;

        this.height = height;
        this.width = width;

        if (option.animation) {
            option['class'] += ' modal-in';
        }

        option['class'] = option['class'] || ''

        this.el.attr('class', struct.containerClass + ' ' + option['class']);

        //标题
        if (option.title || option.closeIcon) {

            var dialogTitle = $('<div/>').addClass(struct.headClass);
            this.mainEl.prepend(dialogTitle);

            if (option.title) {
                dialogTitle.append($(struct.titleTag).html(option.title));
            }
            if (option.closeIcon) {
                var closeIcon = $(struct.closeTag).addClass(struct.closeClass).attr({
                    'title': dialogBtnTxt.close,
                    'href': 'javascript:;'
                }).html('<i>×</i>');
                dialogTitle.append(closeIcon);

                // 点击 X 取消
                closeIcon.on('click', function () {
                    _self.defaultCancel();
                });
            }
        }

        this.contentEl.addClass(struct.bodyClass);

        //内容
        this.contentEl.html(html);

        var ifr = this.el.find("iframe")[0];
        if (ifr) {
            ifr.callback = option.callback;
        }

        //按钮
        if (option.button) {
            var dialogFooter = $('<div/>').addClass(struct.footerClass);
            var dialogButton = struct.buttonWrapper
                ? $(struct.buttonWrapper).appendTo(dialogFooter)
                : dialogFooter;

            if (option.beforeButtonHtml) {
                dialogButton.append(option.beforeButtonHtml).append(' ');
            }

            var _index = 0;
            for (var key in option.button) {

                var btnClassName = struct.buttonClass;

                if (option.buttonHighlight[_index] || option.buttonHighlight[_index] == undefined) {
                    btnClassName += ' ' + struct.buttonPrimaryClass;
                } else {
                    btnClassName += ' ' + struct.buttonWeakClass;
                }

                if (option.buttonDisable[_index]) {
                    btnClassName += ' ' + struct.buttonDisableClass;
                }

                var btn = $(struct.buttonTag).addClass(btnClassName).html('<span>' + key + '</span>');
                var btnFun = option.button[key];
                (function (_btn, _btnFun) {
                    _btn.on('click', function () {
                        var $this = $(this);
                        if ($this.hasClass(struct.buttonDisableClass)) {
                            return
                        }
                        if (option.preventResubmit) {
                            $this.addClass(struct.buttonDisableClass);
                        }
                        (typeof (_btnFun) == 'function') && _btnFun(_btn, _self.el);
                    });
                })(btn, btnFun);

                dialogButton.append(btn).append(' ');
                _index++;
            }
            // 【取消】按钮
            if (option.defaultCancelBtn) {
                var cancelbtn = $(struct.buttonTag)
                    .addClass(struct.buttonClass + " " + struct.buttonWeakClass)
                    .html('<span>' + dialogBtnTxt.cancel + '</span>');
                dialogButton.append(cancelbtn);
                cancelbtn.on('click', function () {
                    _self.defaultCancel();
                });
            }
            this.mainEl.append(dialogFooter);
        }

        // 按下ESC关闭
        $(document).off(KEY_DOWN_EVENT).on(KEY_DOWN_EVENT, function (e) {
            // ESC
            if (e.which === 27 && option.esc) {
                e.preventDefault();
                _self.defaultCancel();
            }
        });

        //显示
        this.el.css({
            'width': width,
            'height': height
        });

        if (option.struct !== 'origin') {
            this.mainEl.css({
                'width': 'auto',
                'height': height
            });
        }

        this.box.show();

        this.center();

        //mask
        if (option.mask) {

            mask.render_if();
            mask.show();

            var $mask = this.mask.add(this.box);
            $mask.off('click');

            if (option.isMaskClickHide) {
                $mask.on('click', function (e) {
                    if ($mask.is(e.target)) {
                        _self.defaultCancel();
                    }
                });
            }
        }

        if (option.time) {
            setTimeout(function () {
                _self.hide();
            }, option.time);
        }

        if (option.onload) {
            option.onload.call(this, this.el)
        }

        if (option.owner) {
            this.owner = option.owner;
        }

        return this.el;
    },


    /**
     * 默认关闭|取消行为
     */
    defaultCancel: function () {
        var option = this.option;
        this.hide();
        option.defaultCancelCb && option.defaultCancelCb();
    },

    /**
     * 隐藏对话框
     * @method hide
     * @author evanyuan
     */
    hide: function () {
        if (!this.struct) return;

        var leaveTransitionClass = this.struct.leaveTransitionClass;
        var enterTransitionClass = this.struct.enterTransitionClass;

        if (!this.el || this.el.hasClass(leaveTransitionClass)) {
            return
        }
        var _self = this, option = this.option;
        this.mask && this.mask.off('click') && mask.hide();
        if (option.animation) {
            util.animationend(this.el[0], function () {
                if (_self.el.hasClass(leaveTransitionClass)) {
                    _self.destroy();
                }
            });
            this.el.removeClass(enterTransitionClass).addClass(leaveTransitionClass);
        } else {
            _self.destroy();
        }
    },

    /**
     * 检测页面是否存在打开的对话框
     * @method isShow
     * @author evanyuan
     */
    isShow: function () {
        return this.el && this.el.is(':visible')
    },

    /**
     * 锁定弹窗，不让用户修改
     * @param {Boolean} freezed
     * @param {jQueryElement} $el (optional) 要锁定的dom元素，可以为供外部使用
     */
    freeze: function (freezed, $el) {
        var cls = 'content-freeze-mask',
            pointerEvents = 'pointer-events',
            me = this,
            $content = $($el || me.contentEl),
            $block = $content.siblings('.' + cls);
        if (freezed) {
            if (!$block.length) {
                $block = $('<div></div>').css({
                    position: 'absolute',
                    zIndex: 1001,
                    backgroundColor: 'gray',
                    opacity: 0
                }).addClass(cls).appendTo($content.parent());
            }
            $block.show().offset($content.offset()).width($content.outerWidth()).height($content.outerHeight());
            $(document.activeElement).blur();
            $content.css(pointerEvents, 'none');
        } else {
            $block.hide();
            $content.css(pointerEvents, '');
        }
        return me;
    },

    /**
     * 切换按钮的loading显示
     * @param loading
     * @param index
     */
    toggleBtnLoading: function (loading, index) {
        index = index || 0;
        var $btn = (index === +index) ? this.getBtn(index) : $(index),
            $loading = $btn.find('i');

        if (loading) {
            if (!$loading.length) {
                $loading = $('<i class="n-loading-icon"></i>').prependTo($btn);
            }
        } else {
            $loading.remove();
        }
        return this;
    },

    /**
     * 切换按钮灰化
     * @method toggleBtnDisable
     * @param  {Bool} disable 是否灰化
     * @param  {Int} index 按钮序号
     * @param  {String} errTips 按钮灰掉后鼠标移上去所给予的提示内容
     * @author evanyuan
     */
    toggleBtnDisable: function (disable, index) {
        var options = {};
        if (typeof disable === 'object') {
            options = disable;
        } else {
            options.disable = disable;
            options.index = index;
        }
        var struct = this.struct;

        if (!struct) return this;
        var disableClass = struct.buttonDisableClass

        options.index = options.index || 0;
        var btn = this.getBtn(options.index);

        if (options.disable) {
            btn.addClass(disableClass);
        } else {
            btn.removeClass(disableClass);
        }
        var self = this;
        self.$errEl && self.$errEl.remove();
        if (options.errTips) {
            self.$errEl = self.$errEl || $('<div class="tc-15-bubble" style="overflow: hidden; max-width: 360px; padding: 4px 10px; z-index: 9999; "><div class="tc-15-bubble-inner"></div></div>');
            self.$errEl.find('.tc-15-bubble-inner').text(options.errTips);
            btn.off('mousemove').on('mousemove', function (e) {
                self.$errEl.css({ left: e.clientX + 15 + "px", top: e.clientY + 20 + "px" }).appendTo(document.body);
            }).off('mouseout').on('mouseout', function (e) {
                self.$errEl.remove();
            }).css({ cursor: 'not-allowed' });
        } else {
            btn.off('mousemove').off('mouseout').css({ cursor: 'default' });
        }

        return this;
    },

    /**
     * 获取按钮Dom
     * @param {Number} index
     * @returns {jQueryElement} $btn
     */
    getBtn: function (index) {
        var struct = this.struct;
        if (!struct) return null;

        return this.el.find('.' + struct.footerClass).find('.' + struct.buttonClass).eq(index);
    },

    /**
     * 居中对话框
     */
    center: function () {
        var option = this.option;
        var win = $(window),
            winHeight = win.height();

        //位置
        var _top = Math.max(0, (option.top || parseInt((winHeight - (this.height || this.el.height())) / 2)) * 0.7);
        this.el.css({
            'top': _top,
            'margin': '10px auto'
        });
    },

    /**
     * 销毁对话框
     */
    destroy: function () {
        if (this.box && this.el) {
            var struct = this.struct;
            this.box.hide();
            this.contentEl && this.contentEl.html('').attr('class', '').removeAttr("style");
            this.mainEl.find('> .' + struct.headClass).remove();
            this.mainEl.find('> .' + struct.footerClass).remove();
            this.owner = null;
            $(document).off(KEY_DOWN_EVENT);
            this.freeze(false);
        }
    },

    /**
     * 确认对话框
     * @method confirm
     * @param  {String}   htmStr   html字符串
     * @param  {Function} sucCb    确认回调
     * @param  {Function} failCb   取消回调
     * @param  {String}   [title]  对话框标题
     * @param  {Number}   [width]  宽度
     * @param  {String}   [mainBtnName] 确认按钮名称
     * @param  {Bool}     [defaultCancelBtn] 取消按钮补全
     * @param  {Bool}     [hideIcon] 隐藏图标
     * @author evanyuan
     */
    confirm: function (htmStr, sucCb, failCb, title, width, mainBtnName, defaultCancelBtn, hideIcon) {

        var objPara = {};
        if (typeof (title) == 'object') {
            objPara = title;
            title = objPara.title;
            width = objPara.width;
            mainBtnName = objPara.mainBtnName;
            defaultCancelBtn = objPara.defaultCancelBtn;
            hideIcon = objPara.hideIcon;
        }

        var icoHtml = hideIcon ? '' : '<td height="72" class="i"><i class="ico ico-warn mr10"></i></td>';
        htmStr = '<div class="coin-alert">' +
            '<table class="ui-popmsg"><tbody><tr>' +
            icoHtml +
            '<td height="72" class="t"><span class="info">' + htmStr + '</span></td>' +
            '</tr></tbody></table>' +
            '</div>';

        var dialogBtnTxt = nmcConfig.dialogBtnTxt;
        defaultCancelBtn = defaultCancelBtn == undefined ? true : defaultCancelBtn;

        var options = {
            title: title || dialogBtnTxt.tips,
            isMaskClickHide: 0,
            isFromConfirm: 1,
            preventResubmit: true,
            button: {},
            defaultCancelBtn: defaultCancelBtn,
            defaultCancelCb: function () {
                failCb && failCb();
            }
        };

        mainBtnName = mainBtnName || dialogBtnTxt.submit;
        options.button[mainBtnName] = function () {
            sucCb && sucCb();
            dialog.hide();
        };

        dialog.create(htmStr, width, '', options);
    },

    /**
     * 设置对话框可见性，可用于隐藏而不销毁对话框
     */
    setVisibility: function (visible) {
        if (this.el && this.mask) {
            this.el.parent().css({ 'display': visible ? 'block' : 'none' });
            this.mask.css({ 'display': visible ? 'block' : 'none' });
        }
    }
};
export default dialog;
